import React from 'react';
import { Link, Modal, Badge } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';

export const LinkCell = (props) => {
  const { cell } = props;
  const { script, isTestExecution = false } = cell?.row?.original;
  const { actions } = cell?.column || {};

  return (
    <div className="fx actr g10 nowrap">
      <div className="fx actr">
        <SVGIcon name="Script" />
      </div>
      <Link
        removeUnderline
        ellipsis
        onClick={actions?.onClick.bind(this, cell)}
      >
        {script?.name}
      </Link>
      {isTestExecution && (
        <Badge>
          <FormattedMessage id="admin.scripts.TestScript" />
        </Badge>
      )}
    </div>
  );
};
